import axios from "axios";
import { serviceUrl } from "../../config";

const BACKEND_URL = serviceUrl;

export const TransactionAudit = async (startdate, enddate) => {
  let startingDate;
  let endingDate;

  if (startdate == null || enddate == null) {
    let today = new Date();
    endingDate = today.toISOString().split("T")[0];
    let thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 360);
    startingDate = thirtyDaysAgo.toISOString().split("T")[0];
  } else {
    startingDate = startdate;
    endingDate = enddate;
  }

  try {
    const data = JSON.stringify({
      svc: "accounting",
      pid: "TransactionAudit",
      dat: {
        date1: startingDate,
        date2: endingDate,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const TransactionAuditCities = async (
  city1,
  city2,
  city3,
  city4,
  city5
) => {
  city1 = city1 || "!";
  city2 = city2 || "!";
  city3 = city3 || "!";
  city4 = city4 || "!";
  city5 = city5 || "!";

  try {
    const data = JSON.stringify({
      svc: "compliance",
      pid: "getComplianceCities",
      dat: {
        city1: city1,
        city2: city2,
        city3: city3,
        city4: city4,
        city5: city5,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const TransactionAuditCorridors = async () => {
  try {
    const data = JSON.stringify({
      svc: "compliance",
      pid: "getComplianceCorridors",
      dat: {},
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const TransactionAuditFlipping = async () => {
  try {
    const data = JSON.stringify({
      svc: "compliance",
      pid: "getComplianceFlipping",
      dat: {},
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const TransactionAuditOneToMany = async (param) => {
  try {
    const data = JSON.stringify({
      svc: "compliance",
      pid: "getComplianceOneToMany",
      dat: { param: param },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const TransactionAuditManyToOne = async (param) => {
  try {
    const data = JSON.stringify({
      svc: "compliance",
      pid: "getComplianceManyToOne",
      dat: { param: param },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getComplianceFlippingDetails = async (param) => {
  try {
    const data = JSON.stringify({
      svc: "compliance",
      pid: "getComplianceFlippingDetails",
      dat: { param: param },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const getCompliancebyUser = async (param) => {
  try {
    const data = JSON.stringify({
      svc: "compliance",
      pid: "getCompliancebyUser",
      dat: { param: param },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getGlobalTransactionSplitting = async (param) => {
  try {
    const data = JSON.stringify({
      svc: "compliance",
      pid: "getGlobalTransactionSplitting",
      dat: { param: param },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getGlobalTransactionStatus = async (param) => {
  try {
    const data = JSON.stringify({
      svc: "compliance",
      pid: "getGlobalTransactionStatus",
      dat: { param: param },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getGlobalPurpose = async (param) => {
  try {
    const data = JSON.stringify({
      svc: "compliance",
      pid: "getGlobalPurpose",
      dat: { param: param },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getGlobalOccupations = async (param) => {
  try {
    const data = JSON.stringify({
      svc: "compliance",
      pid: "getGlobalOccupations",
      dat: { param: param },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getGlobalIncompleteAddress = async (param) => {
  try {
    const data = JSON.stringify({
      svc: "compliance",
      pid: "getGlobalIncompleteAddress",
      dat: { param: param },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};
